import React from "react";
import { Images } from "@/assets";

function PasswordLoginPanel(props) {
    const [showPassword, setShowPassword] = React.useState(false);
    const {
        form,
        agreement,
        onAgreementChange,
        onChange,
        onSubmit,
        onForgotPassword,
    } = props;
    const togglePassword = () => {
        setShowPassword((value) => !value);
    };

    return (
        <div className="loginPasswordTab loginTab">
            <div className="input">
                <input
                    inputMode="numeric"
                    maxLength={11}
                    onChange={(e) => onChange(e, "phone")}
                    placeholder="请输入手机号"
                    value={form.phone}
                />
            </div>
            <div className="input passwordInput">
                <input
                    maxLength={25}
                    onChange={(e) => onChange(e, "password")}
                    placeholder="请输入密码"
                    type={showPassword ? "text" : "password"}
                    value={form.password}
                />
                <button
                    aria-label={showPassword ? "隐藏密码" : "显示密码"}
                    className={showPassword ? "passwordToggle isVisible" : "passwordToggle"}
                    onClick={togglePassword}
                    type="button"
                >
                    <img
                        alt=""
                        src={
                            showPassword
                                ? "https://img.dmallcdn.com/dshop/202607/5b3b9d3a-43f4-430a-95c9-b9720ab13c89"
                                : "https://img.dmallcdn.com/dshop/202607/bb4b638e-2054-4258-a97e-781952df89f5"
                        }
                    />
                </button>
            </div>
            <div className="erropTip">
                {form.err && (
                    <div className="errorTipView">
                        <img src={Images.errorTipPic} />
                        <span>{form.err}</span>
                    </div>
                )}
            </div>
            <div className="button" onClick={onSubmit}>
                登录
            </div>
            <div className="passwordActionView">
                <a className="forgotPasswordLink" onClick={onForgotPassword}>
                    忘记密码
                </a>
            </div>
            <div className="loginTipView">
                <input
                    checked={agreement === 2}
                    onChange={(e) => onAgreementChange(e)}
                    type="checkbox"
                />
                <div>
                    我已同意<a onClick={() => props.goToDoc()}>《麦鲜达隐私协议》</a>
                </div>
            </div>
        </div>
    );
}

export default PasswordLoginPanel;
